import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {GetCoordinatesQuery} from "../../types/api/map/map.types";

export const mapService = {
    panelData: () =>
        apiCall.get(apiUrls.mapMonitoring.panelData),

    getCoordinatesGeofenceAndCP: (query: GetCoordinatesQuery) =>
        apiCall.post(apiUrls.mapMonitoring.getCoordinatesGeofenceAndCP, query),
}